import Icon from '@material-ui/icons/YoutubeSearchedFor';
//import Icon from '@material-ui/icons/FormatListBulleted';
import List from './LookbackList';

export default {
    list: List,
    icon: Icon,
};